import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListTitleDirective } from './list-title.directive';

@NgModule({
  declarations: [ListTitleDirective],
  imports: [CommonModule],
  exports: [ListTitleDirective],
})
export class ListTitleModule {}
